import { Box, CircularProgress } from "@mui/material";
import { useState } from "react";
import { ServiceItem } from "orderme-api-integration-client";
import { ImageLoader } from "../imgLoader/imgLoader";
import { apiKey, imagesUri } from "../../helpers/clientConfigs";
import { DiscountImage, DiscountTypography } from "../serviceLogoItem/serviceLogoItemStyles";
import tag from "../../logo/tag.png"

interface GoodsItemImageProps {
    service: ServiceItem
}

export function GoodsItemImage(props: GoodsItemImageProps) {
    const { service } = props;
    const [imageLoaded, setImageLoaded] = useState(false);

    const getSecondaryImage = (service: ServiceItem) => {
        if (service.images.length > 0)
            return service.images[0].imageId;

        return service.logoId;
    }

    const onImageLoaded = () => {
        setImageLoaded(true);
    }

    return (
        <>{!imageLoaded
            && (
                <Box
                    sx={{
                        height: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                </Box>
            )
        }
            <Box sx={{
                position: "relative",
            }}>
                <ImageLoader
                    sx={{
                        width: "100%",
                        height: "100%",
                        maxHeight: "300px",
                        objectFit: "cover",
                        transition: "opacity 0.5s",
                        '&:hover': {
                            opacity: 0,
                        },
                    }}
                    onLoad={onImageLoaded}
                    src={`${imagesUri}/${service.logoId}?orderme-api-key=${apiKey}&height=500`}
                    alt={service.name} />
                <ImageLoader
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "opacity 0.5s",
                        opacity: 0,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        '&:hover': {
                            opacity: 1,
                        },
                    }}
                    src={`${imagesUri}/${getSecondaryImage(service)}?orderme-api-key=${apiKey}&height=500`}
                    alt={service.name} />

                {imageLoaded && service.discount > 0 && (
                    <>
                        <DiscountImage alt="" src={tag} />
                        <DiscountTypography> -{service.discount} %</DiscountTypography>
                    </>
                )}
            </Box>
        </>
    );
}